export default "<div class=\"overlay\">\r\n    <div class=\"loader\"></div>\r\n</div>\r\n"